import { cn } from '@/lib/utils';

interface BarChartSkeletonProps {
  className?: string;
  barCount?: number;
  barGap?: number;
  animated?: boolean;
  showXAxis?: boolean;
  showYAxis?: boolean;
}

export const BarChartSkeleton = ({
  className,
  barCount = 12,
  barGap = 8,
  animated = true,
  showXAxis = true,
  showYAxis = true,
}: BarChartSkeletonProps) => (
  <div className={cn('w-full space-y-2', className)}>
    <div className='flex h-[200px] items-end gap-[8px]'>
      {showYAxis && (
        <div className='mr-2 h-full w-8'>
          <div className='flex h-full flex-col justify-between py-1'>
            <div className='bg-muted h-2 w-6 rounded'></div>
            <div className='bg-muted h-2 w-4 rounded'></div>
            <div className='bg-muted h-2 w-5 rounded'></div>
            <div className='bg-muted h-2 w-3 rounded'></div>
            <div className='bg-muted h-2 w-6 rounded'></div>
          </div>
        </div>
      )}
      <div className='flex h-full flex-1 items-end gap-[8px]'>
        {Array.from({ length: barCount }).map((_, i) => {
          // Generate random heights between 20% and 90%
          const heightPercentage = Math.floor(Math.random() * 70) + 20;

          return (
            <div
              key={i}
              className={cn(
                'bg-muted flex-1 rounded-t',
                animated && 'animate-pulse'
              )}
              style={{
                height: `${heightPercentage}%`,
                marginLeft: i > 0 ? `${barGap}px` : 0,
              }}
              aria-hidden='true'
            />
          );
        })}
      </div>
    </div>

    {showXAxis && (
      <div className={cn('flex gap-[8px] pl-10')}>
        {Array.from({ length: barCount }).map((_, i) => (
          <div
            key={i}
            className={cn(
              'bg-muted h-2 flex-1 rounded',
              animated && 'animate-pulse'
            )}
            style={{
              marginLeft: i > 0 ? `${barGap}px` : 0,
            }}
            aria-hidden='true'
          />
        ))}
      </div>
    )}
  </div>
);
